"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LightningId;
(function (LightningId) {
    // First satisfation survey
    LightningId["UserVoiceSatisfactionFirstRun"] = "0";
    // Second satisfaction survey
    LightningId["UserVoiceSatisfactionSecondRun"] = "1";
    // Static Image first-run experience for consumer refresh opt-in
    LightningId["ConsumerRefreshFRE"] = "2";
    // Animated first-run experience for consumer refresh opt-in
    LightningId["AnimatedConsumerRefreshFRE"] = "3";
    // Animated first-run experience for consumer refresh opt-in
    LightningId["AnimatedConsumerRefreshFRE2"] = "4";
    // Setting panel first run callout
    LightningId["SettingPanelFirstRunCallout"] = "5";
    // Setting icon first run callout
    LightningId["SettingIconFirstRunCallout"] = "6";
    // Callout for add storage account
    LightningId["AddStorageAccountCallout"] = "7";
})(LightningId = exports.LightningId || (exports.LightningId = {}));
//# sourceMappingURL=LightningId.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-lightning/lib/components/LightningId.js
// module id = 1623
// module chunks = 2 47 105 106 107